/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Funnel = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 14 18">
      <path d="M6.5,17.4 C5.7,17.4 5,16.7 5,15.9 L5,9.2 C5,9.1 5,9 4.9,8.9 L0.9,4.2 C0.7,3.9 0.5,3.6 0.5,3.2 L0.5,1.6 C0.5,0.8 1.2,0.1 2,0.1 L12,0.1 C12.8,0.1 13.5,0.8 13.5,1.6 L13.5,3.2 C13.5,3.6 13.4,3.9 13.1,4.2 L9.1,8.9 C9,8.9 9,9 9,9.1 L9,15.3 C9,15.9 8.7,16.4 8.2,16.6 L7.2,17.1 C7,17.3 6.7,17.4 6.5,17.4 Z M2,1 C1.7,1 1.5,1.2 1.5,1.5 L1.5,3.1 C1.5,3.2 1.5,3.3 1.6,3.4 L5.6,8.1 C5.8,8.4 6,8.7 6,9.1 L6,15.8 C6,16.2 6.4,16.4 6.7,16.2 L7.7,15.7 C7.9,15.6 8,15.4 8,15.3 L8,9.1 C8,8.7 8.1,8.4 8.4,8.1 L12.4,3.4 C12.5,3.3 12.5,3.2 12.5,3.1 L12.5,1.5 C12.5,1.2 12.3,1 12,1 L2,1 Z" />
    </BaseSvgIcon>
  )
}

export default Funnel
